import type { CloseDialogFn } from '@wui/common-library'

type BindCloseDialog = (close: CloseDialogFn<unknown>) => void

type OpenCallSessionDialog = (
  sessionId: string,
  bindCloseDialog: BindCloseDialog,
) => Promise<unknown>

let openCallSessionDialogImpl: OpenCallSessionDialog | null = null

export const registerCallSessionDialog = (open: OpenCallSessionDialog): void => {
  openCallSessionDialogImpl = open
}

export const openCallSessionDialog = (
  sessionId: string,
  bindCloseDialog: BindCloseDialog,
): Promise<unknown> => {
  return openCallSessionDialogImpl?.(sessionId, bindCloseDialog) ?? Promise.resolve()
}
